<template lang="html">
  <div class="checkable-text col-12 p-0 form-row align-items-center mx-0 my-2">
    <div v-if="label" class="col-12">
      <label class="font-weight-bold" for="">{{ label }}</label>
    </div>
    <div :class="checkboxesClass">
      <span class="checkable-text-unverified" v-if="unverified">*</span>
      <input
        @blur="validate"
        @focus="handleFocus"
        @keyup.enter="validate"
        :pattern="pattern"
        :disabled="textDisabled"
        :type="type || 'text'"
        class="form-control"
        :class="unverified && 'pl-4'"
        :style="(editable || deletable) && 'padding-right: 2.5rem'"
        v-model="ivalue">
      <div v-if="deletable || editable" class="checkable-text-icons">
        <font-awesome-icon v-if="editable"
                           @click="$emit('edit')"
                           :icon="[ 'fas', 'edit' ]"
                           :class="`checkable-text-icons-icon${deletable ? ' spaced' : ''}`" />
        <font-awesome-icon v-if="deletable"
                           @click="$emit('delete')"
                           :icon="[ 'fas', 'times' ]"
                           class="checkable-text-icons-icon" />
      </div>
    </div>

    <!-- public data -->
    <div v-if="!noCheckbox" class="col-2 col-md-1 pt-2 d-flex justify-content-center">
      <Tooltip v-if="tooltipText"
               :text="tooltipText"
               :position="'left'"
               noClose
               gray>
        <InlineCheck
          @checkChanged="$emit('checkChanged')"
          :isChecked="isChecked"
          :checkDisabled="checkDisabled" />
      </Tooltip>
      <template v-else>
        <InlineCheck
          @checkChanged="$emit('checkChanged')"
          :isChecked="isChecked"
          :checkDisabled="checkDisabled" />
      </template>
    </div>

    <!-- whatsapp enabled -->
    <div v-if="!noCheckbox && isPhone" class="col-2 col-md-1 pt-2 d-flex justify-content-center">
      <Tooltip v-if="tooltipText"
               :text="tooltipText"
               :position="'left'"
               noClose
               gray>
        <InlineCheck
          @checkChanged="$emit('check2Changed')"
          :isChecked="isChecked2"
          :checkDisabled="checkDisabled" />
      </Tooltip>
      <template v-else>
        <InlineCheck
          @checkChanged="$emit('check2Changed')"
          :isChecked="isChecked2"
          :checkDisabled="checkDisabled" />
      </template>
    </div>

    <div v-if="errors" class="col-12">
      <small class="text-danger">
        {{ errorMessage }}
      </small>
    </div>

  </div>
</template>

<script>
import InlineCheck from './InlineCheck'

export default {
  components: {
    InlineCheck
  },

  props: {
    label: String,
    isChecked: Boolean,
    isChecked2: Boolean,
    value: String,
    pattern: String,
    errorMessage: String,
    checkDisabled: Boolean,
    textDisabled: Boolean,
    // Allows to set the type of input field
    type: String,
    // Hides the checkbox
    noCheckbox: Boolean,
    // if it is a phone, we show whatsapp checkbox
    isPhone: Boolean,
    // Shows an icon to delete the value, emitting a 'delete' event
    deletable: Boolean,
    // Shows an icon to edit the value, emitting an 'edit' event
    editable: Boolean,
    // If true, shows a red tip to the left of the text
    unverified: Boolean,
    // Text to show on checkbox hover
    tooltipText: String
  },

  data: () => ({
    errors: false,
    ivalue: '',
    hasChanged: false
  }),

  computed: {
    checkboxesClass () {
      if (this.noCheckbox)
        return "col-12 p-0"
      else if(this.isPhone)
        return "col-8 col-md-10 p-0"
      else
        return "col-10 col-md-11 p-0"
    },
  },

  watch: {
    value (value) { this.ivalue = value },

    ivalue () { this.hasChanged = true }
  },

  methods: {
    validate (e) {
      if (!this.hasChanged) return
      else this.hasChanged = false

      const value = this.ivalue

      if (this.pattern) {
        if (value === '') {
          return this.$emit('textChanged', value)
        }
        const re = new RegExp(this.pattern)
        if (!value.match(re)) {
          this.errors = true
          e.target.classList.add('is-invalid')

          return
        }
      }

      this.$emit('textChanged', value)
    },

    handleFocus (e) {
      this.$emit('focus')
      if (this.errors) {
        this.errors = false
        e.target.classList.remove('is-invalid')
      }
    }
  },

  mounted () {
    this.ivalue = this.value
  }
}
</script>

<style lang="scss">
  @import '../../../scss/colors';

  .checkable-text {
    label {
      color: $dark;
      font-weight: 500;
    }

    &-icons {
      display: flex;
      position: absolute;
      right: 1rem;
      top: 0;
      bottom: 0;
      color: $secondary;

      &-icon {
        cursor: pointer;
        align-self: center;
      }
    }

    &-unverified {
      color: red;
      position: absolute;
      left: 9px;
      top: 13px;
      height: 12px;
      line-height: 12px;
    }
  }

  .spaced {
    margin-right: 0.5rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/ui/forms/CheckableText.vue